interface Data {
  title: string;
  subTitle?: string;
  tables: {
    title?: string;
    header: string[];
    body: (string | number | undefined)[][];
  }[];
}

export type DataExporter = () => Data;

export function makeFilename(data: Data) {
  return `${[data.title, data.subTitle].filter(Boolean).join('').replace(/ /g, '')}`;
}
